"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _core = require("@material-ui/core");

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["radioProps"],
    _excluded2 = ["helperText", "error", "title", "values", "onChange", "value", "childProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getElement(_ref, _ref2) {
  var value = _ref.value,
      label = _ref.label;
  var radioProps = _ref2.radioProps,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, _objectSpread({
    value: value,
    control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Radio, _objectSpread({
      color: "primary"
    }, radioProps)),
    label: label
  }, rest), "radio-".concat(value));
}

function TextRadio(props) {
  var helperText = props.helperText,
      error = props.error,
      title = props.title,
      values = props.values,
      onChange = props.onChange,
      value = props.value,
      childProps = props.childProps,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
    error: error,
    children: [!!title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormLabel, {
      component: "legend",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.RadioGroup, _objectSpread(_objectSpread({
      "aria-label": title,
      name: "radio-buttons-group",
      onChange: onChange,
      value: value
    }, rest), {}, {
      children: values.map(function (el) {
        return getElement(el, childProps);
      })
    })), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormHelperText, {
      error: error,
      children: helperText
    })]
  });
}

TextRadio.defaultProps = {
  disabled: false,
  values: [],
  childProps: {}
};
TextRadio.propTypes = {
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  title: _propTypes.default.string,
  values: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.string,
    label: _propTypes.string
  })),
  error: _propTypes.default.bool,
  value: _propTypes.default.string,
  childProps: _propTypes.default.object,
  onChange: _propTypes.default.func
};
var _default = TextRadio;
exports.default = _default;
//# sourceMappingURL=TextRadio.js.map